import { render, staticRenderFns } from "./approvalNotificationDetails.vue?vue&type=template&id=1a1e996b&scoped=true"
import script from "./approvalNotificationDetails.vue?vue&type=script&lang=js"
export * from "./approvalNotificationDetails.vue?vue&type=script&lang=js"
import style0 from "./approvalNotificationDetails.vue?vue&type=style&index=0&id=1a1e996b&prod&scoped=true&lang=css"
import style1 from "./approvalNotificationDetails.vue?vue&type=style&index=1&id=1a1e996b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e996b",
  null
  
)

export default component.exports